import React, { ReactNode } from 'react'

import { Container } from './styles'

type Props = {
  children: ReactNode
}

function Main({ children }: Props) {
  return <Container>{children}</Container>
}

export default Main
